import moment from "moment"
// utils
import {retrieveSurvey} from "uprise-surveys/lib/surveys/index"
import {retrieveResults} from "uprise-surveys/lib/surveys/getScore"

export const calcWellbeingScores = surveyResults => {
	let who5 = []
	let stress = []
	let who5Result
	let stressResult

	for (const result of surveyResults) {
		if (result.completed) {
			switch (result.taskId) {
				case "survey-onboarding":
				case "survey-stress-wellbeing-weekly":
				case "survey-stress-wellbeing-monthly":
					who5.push(retrieveResults(result).who5)
					stress.push(retrieveResults(result).stress)
					break
				case "survey-progress":
					who5.push(retrieveResults(result).who5)
					stress.push(retrieveResults(result).stress)
					break
				case "survey-stress-check":
					stress.push(retrieveResults(result).stress)
					break
				case "survey-wellbeing-check":
					who5.push(retrieveResults(result).who5)
					break
				case "survey-preprogram":
					// check if preprogram contains WHO5 and PSS4 answers
					if (result.answers.WHO5 && result.answers.PSS4) {
						who5Result = retrieveSurvey("wellbeing-check-v1").analysis({WHO5: result.answers.WHO5})
						stressResult = retrieveSurvey("stress-check-v1").analysis({STRESS: result.answers.PSS4})

						who5.push({
							score: who5Result?.WHO5?.WHO5,
							dialogueId: "wellbeingCheck",
							timestamp: result.timestamp
						})
						stress.push({
							score: stressResult.STRESS_SCORE,
							dialogueId: "stressCheck",
							timestamp: result.timestamp
						})
					}
			}
		}
	}

	who5.sort(function (a, b) {
		return b.timestamp - a.timestamp
	})

	stress.sort(function (a, b) {
		return b.timestamp - a.timestamp
	})

	who5 = who5[0] || {dialogueId: "wellbeingCheck"}
	stress = stress[0] || {dialogueId: "stressCheck"}

	return {who5, stress}
}

export const calcFinalCaps = callCapPeriod => {
    let idx = -1
    const finalCaps = [...callCapPeriod]?.reverse()?.find((caps, id) => {
        if (moment().isAfter(moment(caps.startingDate))) {
            idx = callCapPeriod.length -1 - id
            return true
        } else
            return false
    })

    return {...finalCaps, idx}
}

export const check24HrsBookingPermission = (role) => {
	return role?.includes("CREATE_NEW_BOOKING_24HRS") || false
}